var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatMsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2549 14C26.2549 19.799 21.2181 24.5 15.0049 24.5C12.4594 24.5 3.75579 24.5 3.75579 24.5C3.75579 24.5 5.70478 20.1322 4.92477 18.6676C4.17595 17.2616 3.75488 15.6767 3.75488 14C3.75488 8.20101 8.79167 3.5 15.0049 3.5C21.2181 3.5 26.2549 8.20101 26.2549 14Z",
    stroke: "#1E1E1E",
    strokeOpacity: 0.8,
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatMsg);
export default __webpack_public_path__ + "static/media/chatMsg.625c201c86dc4ff1998675d70a2f9b42.svg";
export { ForwardRef as ReactComponent };